<plotly-plot
  *ngIf="labels.length"
  #posneg
  [data]="graph.data"
  [config]="graph.config"
  [layout]="graph.layout"
  (initialized)="afterInit()"
  (click)="updateGraph()"
></plotly-plot>
